import {defineStore, mapActions} from 'pinia';
import ClientService from "../services/ClientService";
import CommonServices from "../services/CommonServices";
import AdminService from "../services/AdminService";
import ArtistService from "../services/ArtistService";

export const useClientStore = defineStore('ClientStore', {
    state: () => {
       return {
           client: {},
           clientId: null,
           generalClientInfo: {},
           companies: [],
           regions: [],
           talentCategories: [],
           listOfArtists: [],
           artistInfo: {},
           listOfBookedArtists: [],
           adminPermissions: false
       }
    },
    getters: {
        artistMedia() {
            return {
                avatar: this.artistInfo.file_avatar,
                photos: this.artistInfo.photos,
                videos: this.artistInfo.videos,
                video_links: this.artistInfo.video_links
            }
        },
        artistId() {
            return this.artistInfo.id
        },
        artistShowInfo() {
            return this.artistInfo.shows
        },
        artistCategories () {
            return this.artistInfo.categories
        }
    },

    actions: {
        setClientId(id) {
            this.clientId = id
        },
        setAdminPermission() {
            this.adminPermissions = true
        },
        async fetchClient(clientId) {

            const uploadMethod = clientId
                ? AdminService.getClientInfo(clientId)
                : ClientService.fetchClientInfo()

            try {
                const { data: response } =  await uploadMethod
                this.client = response
                this.generalClientInfo = response.user
                this.clientId = response.id
            } catch(error) {
                console.log(error)
            }
        },
        async fetchArtist(artistId) {
            try {
                const { data: response } = await ClientService.getArtistInnerInfo(artistId)
                this.artistInfo = response
            } catch (e){
                console.error(e)
            }
        },
        async fetchCompanies() {
            try {
                const { data: response } = await CommonServices.getCompanies()
                this.companies = response
            } catch (e) {
                console.error(e)
            }
        },
        async fetchListOfArtists(page, clientId = this.clientId) {
            try {
                const { data: response } = await ClientService.getListOfArtists(clientId, page)
                this.listOfArtists = response.data
            } catch (e){
                console.error(e)
            }
        },
        async fetchListOfBookedArtists(id, page) {
            try {
                const { data: response } = await ClientService.getListOfBookedArtists(id, page)
                this.listOfBookedArtists = response
            } catch (e){
                console.error(e)
            }
        },
        async fetchRegionList() {
            try {
                const { data: response } = await CommonServices.getRegionsList();
                this.regions = response
            } catch (e) {
                console.error(e);
            }
        }
    },
})
